interface LoadingProps {
  isActive: boolean;
}

export const Loading = ({ isActive }: LoadingProps) => {
  return <div className={`pageloader ${isActive ? 'is-active' : ''} `} />;
};
